module.exports = __webpack_public_path__ + "img/shop-drone.3f66268b.gif";